/*

Nastavit metodu zobrazení položek galerie dle zařízení
  - mobil: scrollování (portrait i landscape)
  - desktop: slider

*/

import Glide from '@glidejs/glide';
import { galleryState as state } from './galleryState';
import { reloadAds } from '@utils/advertisement';
import { galleryScrollToItem as scrollToItem } from './galleryScrollToItem';
import breakpoints from '@breakpoints';

// Přidat slider
export const glide = Glide
  ? new Glide('#gallery-slider', {
      type: 'slider',
      perView: 1,
      focusAt: 'center',
      gap: 0,
      // swipeThreshold: false, // vypnutí swipu
      breakpoints: {
        800: {
          perView: 1,
        },
      },
    })
      .mount()
      .on('move', () => {
        if (
          glide &&
          state.getIsDesktop() &&
          window.innerWidth >= breakpoints.galleryAdvertisement
        ) {
          const position: number = glide.index + 1;
          state.setActiveItem(position);
        } else {
          // Odebrat styly generované sliderem při resize
          const slidesWrapper = state
            .getRootElement()
            .querySelector('[data-slide-or-scroll-items-wrapper]');
          if (slidesWrapper) {
            slidesWrapper.removeAttribute('style');
          }
        }
      })
      .on('swipe.end', () => {
        const zoomModal: HTMLElement | null = document.querySelector('[data-gallery-zoom-modal]');
        // inzertní fci reloadAds(); nevoláme v případě, že je zazoomovaná fotka
        if (zoomModal) {
          const zoomDisplayStyle = window.getComputedStyle(zoomModal).display;
          if (state.getIsDesktop() && zoomDisplayStyle != 'none') {
            reloadAds();
          }
        }
      })
  : undefined;

export const gallerySlideOrScroll = (): void => {
  const number = state.getActiveItem();
  const slidesWrapper = state
    .getRootElement()
    .querySelector('[data-slide-or-scroll-items-wrapper]');

  if (!slidesWrapper) throw new Error('gallerySlideOrScroll: slidesWrapper not found');

  const CLASS_SLIDES = 'glide__slides';
  const CLASS_HIDDEN = 'hidden';

  // Šipky
  const glideControls = document.querySelector('[data-glide-controls]');

  // Pro desktop
  if (state.getIsDesktop()) {
    // Přidat třídu pro slider
    if (slidesWrapper && !slidesWrapper.classList.contains(CLASS_SLIDES))
      slidesWrapper.classList.add(CLASS_SLIDES);

    // Zobrazit ovádací prvky - šipky
    if (glideControls && glideControls.classList.contains(CLASS_HIDDEN))
      glideControls.classList.remove(CLASS_HIDDEN);

    // Jít na konkrétní slide
    if (number && glide) {
      glide.update({ animationDuration: 0 });
      glide.go(`=${number - 1}`);
      glide.update({ animationDuration: 500 });
    }
  } else {
    // Pro mobil

    // Odebrat styly generované sliderem
    slidesWrapper.removeAttribute('style');

    // Odebrat třídu pro slider
    if (slidesWrapper && slidesWrapper.classList.contains(CLASS_SLIDES))
      slidesWrapper.classList.remove(CLASS_SLIDES);

    // Skrýt ovládací prvky - šipky
    if (glideControls && !glideControls.classList.contains(CLASS_HIDDEN))
      glideControls.classList.add(CLASS_HIDDEN);

    // Jít na konkrétní slide
    scrollToItem({
      itemPosition: number - 1,
    });
  }
};
